// Helper : construit un chemin interne dans la langue active.
// Usage : <Link to={localizedPath("/etablissements", lang)}>
// Pour un slug dynamique (ex: établissement), passer le path FR canonique en argument.

import { ROUTE_MAP, type Lang } from "./routes";

export function localizedPath(frPath: string, lang: Lang): string {
  if (lang === "fr") return frPath;
  if (ROUTE_MAP[frPath]) return ROUTE_MAP[frPath];
  // Slug dynamique non mappé → préfixer /en
  return `/en${frPath}`;
}
